<template>
	<v-card>
		<v-layout>
			<v-flex xs5 align-content-center>
				<v-img src="/img/bertha/bertha-mini-multicolor-LightMode.svg" height="80%" contain></v-img>
			</v-flex>
			<v-flex xs7 text-xs-center align-content-center>
				<div class="ai-text">
					<BerthaAIAssistant class="mb-3" height="1.5rem"></BerthaAIAssistant>

					<p>To use Bertha AI Assistant to help generate content,</p>
					<p>please click within the right window panel.</p>
				</div>
			</v-flex>
		</v-layout>
	</v-card>
</template>
<script>
import BerthaAIAssistant from './BerthaAIAssistant.vue';

export default {
	name: 'AIInfoCard',
	components: { BerthaAIAssistant }
};
</script>
<style scoped>
.ai-text {
	height: auto;
}
</style>
